import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    searchData:[],
};
const getters = {
  searchData: (state) => state.searchData,
};

const actions = {
    [actionType.GET_DATA_SEARCH_ADMIN]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api('/admin/listings', {
                method:"GET",
                params : params
            }).then(result => {
                let response = {
                    page: params.page,
                    data: result.data.data
                }
                commit(mutationType.SET_DATA_SEARCH_ADMIN, response)
                resolve(result)
            }).catch(error => reject(error))
        })
    },
    [actionType.GET_NUMBER_OF_LISTING_OF_USER]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api(`/admin/users/countlisting/${params.userId}`, {
                method:"GET",
            }).then(result => {
                resolve(result)
            }).catch(error => reject(error))
        })
    },
};

const mutations = {
    [mutationType.SET_DATA_SEARCH_ADMIN]: function (state, data) {
        if(data.page == 1)
        {
            state.searchData = data.data
        }
        else
        {
            state.searchData = state.searchData.concat(data.data)
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}